module.exports = __webpack_public_path__ + "assets/icon-menu-dots.b665f329.svg";